import { IQueryCreationState } from './queryCreation.initialState.interface';

export const tsParamsInitialState = {
  fetchTypes: null,
  latestValue: null,
  rollup: null,
  timeRange: null,
};

export const initialState: IQueryCreationState = {
  domains: [],
  domainsIsLoading: false,
  domainsHasLoadingError: false,

  domainsWithConceptRelations: [],
  domainsWithConceptRelationsIsLoading: false,
  domainsWithConceptRelationsHasLoadingError: false,

  nodesMap: {},
  superClassMap: {},
  conceptsMap: {},

  query: {},
  queryIsLoading: true,
  queryHasLoadingError: false,
  queryErrorStatus: -1,
  queryConceptsAreAllConnected: true,

  queryMap: {},
  queryGraphOptions: {},
  conceptInstanceIdMap: {},

  filterPropDeps: {},
  allPropertyWindowFunctions: [],
  allCalcWindowFunctions: [],

  selectedConcept: {},
  selectedConceptColor: '',
  selectedConceptId: null,

  queryIsSaving: false,
  queryHasSavingError: false,
  queryIsDoneSaving: false,

  calcsList: [],
  filteredCalcsList: [],
  calcsListIsLoading: false,
  calcsListHasError: false,

  calc: {},
  calcIsLoading: false,
  calcHasError: false,

  isQueryEmpty: false,

  isConfirmDeleteModalOpen: false,
  isPropertyEntity: false,
  isConceptSettingsModalOpen: false,
};
